import { action } from 'typesafe-actions';
import { DASHBOARD } from '../constants/actions';

export const setAllDashboardValues = (payload: any) => action(DASHBOARD.SET_ALL_DASHBOARD_VALUES, payload);
export const getAllDashboardValues = (payload: any) => action(DASHBOARD.GET_ALL_DASHBOARD_VALUES, payload);
export const dismissAbwReminders = (payload: boolean) => action(DASHBOARD.DISMISS_ABW_REMINDERS, payload);
export const dismissCycleCountReminders = (payload: boolean) => action(DASHBOARD.DISMISS_CYCLE_COUNT_REMINDERS, payload);
